import { RangeDateTypeHr } from 'src/types/date.type';
import { FlatItem, TicketResponses } from 'src/types/elements.type';
import { ApprovalStatus } from 'src/types/helpdesk/ticket.type';
import { AdvancePaymentTicketAdd, IAdvancePaymentTicket } from 'src/types/hr_ticket/advancePaymentTicket.type';
import { PagedList } from 'src/types/pagedList.type';
import { IHrTicketParams } from 'src/types/params.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/advance-payment-tickets';

export const getAdvancePaymentTickets = async (params: IHrTicketParams) => {
  return await http.get<PagedList<IAdvancePaymentTicket>>(controller, {
    params: params
  });
};

export const getAdvancePaymentTicketsApproval = async (params: IHrTicketParams) => {
  return await http.get<PagedList<IAdvancePaymentTicket>>(`${controller}/waiting-approval`, {
    params: params
  });
};

export const getAdvancePaymentTicket = async (id: number) => {
  return await http.get<IAdvancePaymentTicket>(`${controller}/${id}`);
};

export const getAdvancePaymentTicketsDropdown = async () => {
  return await http.get<FlatItem[]>(`${controller}/dropdown`);
};

export const printAdvancePaymentTicket = async (id: number) =>
  await http.get(`${controller}/print`, {
    params: {
      id: id
    },
    responseType: 'blob'
  });

export const addAdvancePaymentTicket = async (advancePaymentTicket: AdvancePaymentTicketAdd) => {
  return await http.post(controller, advancePaymentTicket);
};

export const updateAdvancePaymentTicket = async (id: number, advancePaymentTicket: AdvancePaymentTicketAdd) => {
  return await http.put(`${controller}/${id}`, advancePaymentTicket);
};

export const deleteAdvancePaymentTicket = async (id: number) => {
  return await http.delete(`${controller}/${id}`);
};

export const cancelAdvancePaymentTicket = async (id: number) => {
  return await http.put(`${controller}/${id}/cancel`);
};

export const approvalAdvancePaymentTickets = async (
  ticketResponses: TicketResponses[],
  approvalStatus: ApprovalStatus,
  note?: string
) =>
  await http.put(`${controller}/approvals`, {
    ticketResponses: ticketResponses,
    approvalStatus,
    note: note ? note : ''
  });

export const cancelApprovalAdvancePaymentTickets = async (id: string, step: number) =>
  await http.put(`${controller}/${id}/cancel-approval`, { step });

export const getRefAdvancePaymentTicketsForTicket = async (refTicketId: string) =>
  await http.get<IAdvancePaymentTicket[]>(`${controller}/get-ref-tickets/${refTicketId}`);

export const getAdvancePaymentWaitingProcessingCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-ticket-waiting-processing`, {
    params: params
  });
};

export const getMyAdvancePaymentTicketCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-my-tickets`, {
    params: params
  });
};

export const getAdvancePaymentTicketApprovalCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-handle-tickets`, {
    params: params
  });
};
